exports.OOC_CREATED_BY = 'backend-function-ooc-implied-sales'
